import { Dispatch, SetStateAction } from "react";
import { VendedorActions } from "./VendedoresContainer";
import { VendedorItem } from "../../../types/vendedor";
import { VendedorTable } from "./VendedorTable";
import { useAdminPanelUI } from "../../../hooks/useAdminPanelUI";
import AddRoundedIcon from '@mui/icons-material/AddRounded';

interface Props {
    setVendedorSelected: Dispatch<SetStateAction<number>>;
}

export function VendedoresList({ setVendedorSelected }: Props) {
    const { setVendedorAction } = useAdminPanelUI();

    const onOpenDetails = (vendedor: VendedorItem) => {
        setVendedorSelected(vendedor.id);
        setVendedorAction(VendedorActions.VendedorDetails);
    }

    return (
        <div className="h-full w-full overflow-hidden flex flex-col">
            <div className="my-4 mx-2">
                <button 
                    onClick={() => setVendedorAction(VendedorActions.CreateVendedorForm)}
                    className="bg-green-800 h-[30px] w-[90px] rounded px-[6px] py-[4px] flex gap-1 items-center mb-2">
                    <AddRoundedIcon sx={{ height: 15, width: 15, color: "white" }}/>
                    <p className="text-white text-[13px] font-semibold">Vendedor</p>
                </button>
            </div>

            <div className="flex items-center px-3 py-1 w-full h-[32px]">
            </div>

            <p className="font-semibold text-xl mb-2 mx-2">Lista de vendedores</p>

            <div className="flex-1 border-0 border-gray-400 overflow-auto">
                <VendedorTable
                    onOpenDetails={onOpenDetails}/>
            </div>
        </div>
    );
}